import { configureStore } from '@reduxjs/toolkit';
import firebaseReducer from './reducers/firebase/firebaseSlice';

export default configureStore({
  reducer: {
    firebase: firebaseReducer
  }
});
